export class CreateCheckoutException {}